"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Paginator = function () {
  /**
   * Loops through and aggregates all pages from a paginated collection.
   * @constructor
   */
  function Paginator() {
    _classCallCheck(this, Paginator);

    this.data = [];
    this.pages = [];
    this._handleNextPage = this._handleNextPage.bind(this);
  }

  /**
   * Begins the loop through all the pages. The Promise returned will send
   * filled paginator object as the callback parameter.
   *
   *   >>> var request = api.get('/providers/');
   *   >>> var paginator = new Paginator();
   *   >>> paginator.getAll(request).then(function(result) {
   *   ...  console.log(result.data);
   *   ... });
   *   // => [{id: 1}, {id: 2}, etc...]
   *
   * @param {Object} request - The first request of the paginated collection
   * @returns {Promise}
   */


  _createClass(Paginator, [{
    key: "getAll",
    value: function getAll(request) {
      return request.then(this._handleNextPage);
    }
  }, {
    key: "_handleNextPage",
    value: function _handleNextPage(page) {
      this.pages.push(page);
      this.data = this.data.concat(page.data);

      if (page.hasNext()) {
        return page.getNext().then(this._handleNextPage);
      }
      return this;
    }
  }]);

  return Paginator;
}();

exports.default = Paginator;